import Head from 'next/head';
import { Button } from 'antd';
import supportHelpStyles from './support-help.module.scss';
import CommonHelp from '../../components/supportPageComponent/commonHelp/common-help';
import NoticeInfo from '../../components/supportPageComponent/noticeInfo/notice-info';
import { NOTICE_DESC, CONFIG_DESC, BANNER } from '../../utils/const/support';

export default function SupportHelp() {
  return (
    <div>
      <Head>
        <title>Support and Help</title>
      </Head>
      <div className={supportHelpStyles.container}>
        <div className={supportHelpStyles.banner}>
          <div className={supportHelpStyles.content}>
            <div className={supportHelpStyles.title}>{BANNER.title}</div>
            <div className={supportHelpStyles.descText}>{BANNER.content}</div>
            {/* <Button className={supportHelpStyles.button}>
            <span className={supportHelpStyles.buttonText}>立即沟通</span>
          </Button> */}
          </div>
        </div>
        <div className={supportHelpStyles.tools}>
          {CONFIG_DESC.map((item, index) => (
            <CommonHelp
              item={item}
              key={index}
              className={supportHelpStyles.hoverStyle}
            />
          ))}
        </div>
        <div className={supportHelpStyles.board}>
          <div className={supportHelpStyles.part3Info}>
            <div className={supportHelpStyles.noticeTitle}>公告</div>
            <div className={supportHelpStyles.noticeInfo}>
              {NOTICE_DESC.map((item, index) => {
                return (
                  <div key={index}>
                    <NoticeInfo item={item}></NoticeInfo>
                    {/* <div className={supportHelpStyles.oneLine}></div> */}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
